class ValidationInput {
	static validateInput(input, formId) {
		const errorElement = document.querySelector(`.invalid-feedback.error-${ input.id }`);
		const form = document.querySelector(`#${ formId }`);
		const validityState = input.validity;
		
		if (validityState.valueMissing) {
			input.classList.add('is-invalid');
			errorElement.textContent = form.dataset.inputMandatoryKey;
		} else if (validityState.patternMismatch && input.type === 'email') {
			input.classList.add('is-invalid');
			errorElement.textContent = form.dataset.inputInvalidmailKey;
		} else if (validityState.patternMismatch && input.name === 'username') {
			input.classList.add('is-invalid');
			errorElement.textContent = form.dataset.inputInvalidusernameKey;
		} else if (validityState.patternMismatch) {
			input.classList.add('is-invalid');
			errorElement.textContent = input.dataset.translatePatternError;
		} else if (validityState.tooShort) {
			input.classList.add('is-invalid');
			errorElement.textContent = form.dataset.inputShortKey;
		} else if (validityState.tooLong) {
			input.classList.add('is-invalid');
			errorElement.textContent = form.dataset.inputLongKey;
		} else {
			input.classList.remove('is-invalid');
		}
		this.disableSubmitBtn(formId);
	}
	
	static resetInput(input) {
		input.setCustomValidity('');
	}
	
	static checkMismatchInput(input, compareValue, formId) {
		const errorElement = document.querySelector(`.invalid-feedback.error-${ input.id }`);
		if (input.value !== compareValue) {
			input.classList.add('is-invalid');
			errorElement.textContent = input.dataset.translatePatternError;
		} else {
			input.classList.remove('is-invalid');
			ValidationInput.resetInput(event.target);
		}
		this.disableSubmitBtn(formId);
	}
	
	static validatePasswordInput(input, formId) {
		const form = document.querySelector(`#${ formId }`);
		const errorElement = document.querySelector(`.invalid-feedback.error-${ input.id }`);
		const criteriaInputList = {
			'containLowercase': /[a-z]/.test(input.value),
			'containUppercase': /[A-Z]/.test(input.value),
			'containNumber': /\d/.test(input.value),
			'containSpecialCharacter': /[_&#"@%$*!?]/.test(input.value),
		};
		let rulesCheckedCategory = 0;
		
		Object.values(criteriaInputList).map((criteriaInput) => {
			if (criteriaInput) {
				rulesCheckedCategory += 1;
			}
		});
		
		if (rulesCheckedCategory >= parseInt(form.dataset.categoryAccepted)) {
			input.classList.remove('is-invalid');
			errorElement.textContent = '';
			
			this.validateInput(input, formId);
			
			if (input.classList.contains('is-invalid')) {
				input.classList.remove('was-validated');
			} else {
				input.classList.add('was-validated');
			}
			
		} else {
			input.classList.add('is-invalid');
			input.classList.remove('was-validated');
			errorElement.textContent = input.dataset.translatePatternError;
		}
		
	}
	
	static disableSubmitBtn(formId) {
		const inputList = document.querySelectorAll(`#${ formId } input`);
		const selectList = document.querySelectorAll(`#${ formId } select`);
		const submitBtn = document.querySelector(`#${ formId } button[type=submit]`);
		const formHasInvalidInput = (element) => element.classList.contains('is-invalid');
		const emptyValueRequiredInputList = Array.from(inputList).filter((input) => input.value.length === 0 && input.required);
		
		submitBtn.disabled = Array.from(inputList).some(formHasInvalidInput) | Array.from(selectList).some(formHasInvalidInput) | emptyValueRequiredInputList.length > 0;
	}
}

module.exports = ValidationInput;